// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep P{font-size:medium;line-height:normal;font-weight:400;letter-spacing:normal;font-style:normal}.markdown TH{text-align:left}.markdown table tr th{font-weight:700}.markdown table tr td,.markdown table tr th{text-align:left;margin:0;padding:6px 13px}.markdown table tr td :first-child,.markdown table tr th :first-child{margin-top:0}.markdown table tr td :last-child,.markdown table tr th :last-child{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
